import { nameof } from "ts-simple-nameof";
import { IPreReservationFormInputModel } from "../models/preReservationFormInputModel";
import { DefaultInputField } from "../../../../common/components/forms/inputs/InputField/DefaultInputField";
import { DefaultTextareaField } from "../../../../common/components/forms/inputs/textareaField/DefaultTextareaField";
import { FormPlaceholderPalette } from "../../../../common/preReservationForms/FormPlaceholderPalette";
import { FormPreview } from "../../../../common/preReservationForms/FormPreview";
import styles from "./PreReservationFormFormFields.module.scss";

export const PreReservationFormFormFields = () => {
  const templateFieldName = nameof<IPreReservationFormInputModel>(
    (x) => x.templateText,
  );

  return (
    <div className={styles.root}>
      <DefaultInputField
        name={nameof<IPreReservationFormInputModel>((x) => x.name)}
        label="Име на формата"
        placeholder="Декларация за здравословно състояние"
        required
      />

      <FormPlaceholderPalette fieldName={templateFieldName} />

      <DefaultTextareaField
        name={templateFieldName}
        label="Съдържание на формата"
        placeholder="Аз, {{userName}}, декларирам, че..."
        rows={10}
        required
      />

      <FormPreview fieldName={templateFieldName} />
    </div>
  );
};
